import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { api } from "../../api";
import { SectionTitle, StatusPill, EmptyState, Avatar, ShowMore } from "../../components/Atoms";
import { CheckCircle, XCircle, ClipboardText, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";

const TABS = ["Pending", "Approved", "Rejected"];

export default function ApplicationsPage() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("Pending");
  const [visible, setVisible] = useState(10);

  const load = useCallback(async () => {
    const { data } = await api.get(`/applications?status=${tab}`);
    setItems(data);
    setVisible(10);
  }, [tab]);

  useEffect(() => { load(); }, [load]);

  const act = async (id, action) => {
    await api.post(`/applications/${id}/${action}`);
    toast.success(`Application ${action}d`); load();
  };

  return (
    <div className="space-y-5">
      <SectionTitle title="Applications" subtitle="Approve or reject ambassador applications" />
      <div className="flex gap-2 overflow-x-auto no-scrollbar">
        {TABS.map(t => (
          <button key={t} onClick={() => setTab(t)} data-testid={`apps-tab-${t.toLowerCase()}`}
            className={`px-4 py-2 rounded-full text-sm font-bold ${tab === t ? "bg-white/10 text-white border border-white/15" : "text-muted bg-white/5"}`}>{t}</button>
        ))}
      </div>
      {items.length === 0 ? <EmptyState icon={ClipboardText} title={`No ${tab.toLowerCase()} applications`} /> : (
        <>
        <div className="grid sm:grid-cols-2 gap-4">
          {items.slice(0, visible).map(a => (
            <div key={a.id} className="glass p-4 hover-lift" data-testid={`application-${a.id}`}>
              <Link to={`/admin/ambassadors/${a.ambassador_id}`} className="flex items-center gap-3 hover:opacity-80" data-testid={`app-amb-link-${a.id}`}>
                <Avatar src={a.ambassador_photo} name={a.ambassador_name} />
                <div className="flex-1 min-w-0">
                  <div className="text-white font-bold truncate hover:text-[#22D3EE]">{a.ambassador_name}</div>
                  <div className="text-xs text-muted truncate">{(a.ambassador_followers || 0).toLocaleString()} followers · ₹{a.reward_amount}</div>
                </div>
                <StatusPill status={a.status} />
              </Link>
              <div className="mt-3 text-sm text-muted">
                For: <Link to={`/admin/projects/${a.project_id}`} className="text-white font-semibold hover:text-[#22D3EE]">{a.project_title}</Link>
              </div>
              <Link to={`/admin/ambassadors/${a.ambassador_id}`} className="text-[10px] text-[#22D3EE] mt-2 flex items-center gap-1 font-bold" data-testid={`view-profile-${a.id}`}>Review full profile <ArrowRight size={12} weight="bold" /></Link>
              {a.status === "Pending" && (
                <div className="flex gap-2 mt-3">
                  <button onClick={() => act(a.id, "approve")} className="btn-ghost flex-1 text-[#A3E635] flex items-center justify-center gap-1.5 text-sm" data-testid={`approve-app-${a.id}`}><CheckCircle size={16} weight="bold" /> Approve</button>
                  <button onClick={() => act(a.id, "reject")} className="btn-ghost flex-1 text-[#EC4899] flex items-center justify-center gap-1.5 text-sm" data-testid={`reject-app-${a.id}`}><XCircle size={16} weight="bold" /> Reject</button>
                </div>
              )}
            </div>
          ))}
        </div>
        <ShowMore visible={visible} total={items.length} onMore={setVisible} testid="apps-show-more" />
        </>
      )}
    </div>
  );
}
